var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('b-alert',{attrs:{"show":"","variant":"info"}},[_vm._v("Verifying token...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }